// Optional stale-editor protection, not an authentication or authorization source.
export const EXPECTED_WORKSPACE_HEADER = "X-InControl-Expected-Workspace";
export const WORKSPACE_RESPONSE_HEADER = "X-InControl-Workspace-Id";
export const WORKSPACE_CHANGED_CODE = "WORKSPACE_CHANGED";

export function isWorkspaceWrite(method: string): boolean {
  return !["GET", "HEAD", "OPTIONS"].includes(method.toUpperCase());
}
